/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const getHomePageCacheKey = (userSegments?: string[]) => {
  const segmentsKey = userSegments?.sort();
  const key: Array<string | string[]> = ['home', 'response'];

  if (segmentsKey) {
    key.push(segmentsKey);
  }

  return key;
};
